export const MAX_HEIGHT = 250;
export const MAX_WIDTH = 400;

export const imageMatcherUploadPageURL = "/image-matcher/upload";
export const imageMatcherUploadedPageURL = "/image-matcher/uploaded";

export const selectedImageMatcherURL = (id: string | null | undefined) =>
  `${imageMatcherUploadedPageURL}/result/${id}`;

export const selectedManufacturersKey = "selectedManufacturers";
export const selectedItemGroupsKey = "selectedItemGroups";
